import React, { useState } from "react";

import { authAPI } from "../services/api";
import useActionLock from "../hooks/useActionLock";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [busy, runLogin] = useActionLock();

  const handleSubmit = async (e) => {
    e.preventDefault();
    return runLogin(async () => {
    if (!username.trim() || !password) return;
    setError("");
    setLoading(true);

    try {
      const response = await authAPI.login(username.trim(), password);

      // Stocker le token dans localStorage
      sessionStorage.setItem("token", response.data.access_token);
      sessionStorage.setItem("username", response.data.username);

      // Rediriger vers le dashboard
      localStorage.removeItem("token");
      localStorage.removeItem("username");
      navigate(response.data.password_change_required ? "/securite" : "/", { replace: true });
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Connexion indisponible. Réessayez.");
    } finally {
      setLoading(false);
    }
    });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 px-4 py-6">
      <div className="max-w-md w-full space-y-8 rounded-xl bg-white p-6 shadow-2xl sm:p-10">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            FacturaLite
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Connexion requise
          </p>
        </div>

        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="username" className="sr-only">
                Nom d'utilisateur
              </label>
              <input
                id="username"
                name="username"
                type="text"
                autoComplete="username"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="Nom d'utilisateur"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                disabled={loading || busy}
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                Mot de passe
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="Mot de passe"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={loading || busy}
              />
            </div>
          </div>

          {error && (
            <div className="rounded-md bg-red-50 p-4">
              <div role="alert" className="text-sm text-red-800">{error}</div>
            </div>
          )}

          <div>
            <button
              type="submit"
              disabled={loading || busy || !username.trim() || !password}
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? "Connexion..." : "Se connecter"}
            </button>
          </div>
        </form>

        <p className="text-center text-xs text-gray-500">Accès réservé. Utilisez les identifiants configurés pour votre installation.</p>
      </div>
    </div>
  );
};

export default Login;
